(function () {
  const STORAGE_KEY = 'wishlist_products';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: items }));
  }

  function isInWishlist(productId) {
    return getWishlist().some(item => String(item.id) === String(productId));
  }

  function toggleWishlist(product) {
    let items = getWishlist();
    const exists = items.some(item => String(item.id) === String(product.id));

    if (exists) {
      items = items.filter(item => String(item.id) !== String(product.id));
    } else {
      items.unshift(product);
    }

    saveWishlist(items);
    return !exists;
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateButtonState(button) {
    const productId = button.dataset.productId;
    const active = isInWishlist(productId);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function updateAllButtons(scope) {
    const root = scope || document;
    root.querySelectorAll('.js-wishlist-btn').forEach(updateButtonState);
  }

  function updateHeaderCount() {
    const count = getWishlist().length;
    document.querySelectorAll('.header-wishlist__count').forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
  }

  function openWishlistDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    renderWishlistDrawer();
  }

  function closeWishlistDrawer() {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  function renderWishlistDrawer() {
    const list = document.querySelector('.js-wishlist-drawer-list');
    const empty = document.querySelector('.js-wishlist-drawer-empty');
    const count = document.querySelector('.js-wishlist-drawer-count');

    if (!list || !empty || !count) return;

    const items = getWishlist();
    count.textContent = items.length ? `Contains ${items.length} products` : 'No products';

    if (!items.length) {
      list.innerHTML = '';
      empty.style.display = 'block';
      return;
    }

    empty.style.display = 'none';

    list.innerHTML = items.map(item => `
      <div class="wishlist-drawer__item">
        <a class="wishlist-drawer__image" href="${item.url}">
          <img src="${item.image}" alt="${item.title}">
        </a>
        <div>
          <a href="${item.url}" style="text-decoration:none;color:inherit;">
            <div class="wishlist-drawer__name">${item.title}</div>
          </a>
          <div class="wishlist-drawer__price">${formatMoney(item.price)}</div>
        </div>
        <button type="button" class="wishlist-drawer__remove js-wishlist-remove" data-product-id="${item.id}" aria-label="Remove">
          ×
        </button>
      </div>
    `).join('');

    list.querySelectorAll('.js-wishlist-remove').forEach(btn => {
      btn.addEventListener('click', function () {
        const productId = btn.dataset.productId;
        const items = getWishlist().filter(item => String(item.id) !== String(productId));
        saveWishlist(items);
        renderWishlistDrawer();
        updateAllButtons(document);
        updateHeaderCount();
      });
    });
  }

  function bindButtons(scope) {
    const root = scope || document;

    root.querySelectorAll('.js-wishlist-btn').forEach(button => {
      if (button.dataset.wishlistBound === 'true') return;
      button.dataset.wishlistBound = 'true';

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const product = {
          id: button.dataset.productId,
          handle: button.dataset.productHandle,
          title: button.dataset.productTitle,
          url: button.dataset.productUrl,
          image: button.dataset.productImage,
          price: parseInt(button.dataset.productPrice || '0', 10)
        };

        toggleWishlist(product);
        updateAllButtons(document);
        updateHeaderCount();
        openWishlistDrawer();
      });
    });

    root.querySelectorAll('.js-open-wishlist-drawer').forEach(link => {
      if (link.dataset.wishlistDrawerBound === 'true') return;
      link.dataset.wishlistDrawerBound = 'true';

      link.addEventListener('click', function (e) {
        e.preventDefault();
        openWishlistDrawer();
      });
    });

    root.querySelectorAll('.js-wishlist-drawer-close').forEach(el => {
      if (el.dataset.wishlistCloseBound === 'true') return;
      el.dataset.wishlistCloseBound = 'true';

      el.addEventListener('click', function () {
        closeWishlistDrawer();
      });
    });
  }

  function initWishlist(scope) {
    bindButtons(scope || document);
    updateAllButtons(scope || document);
    updateHeaderCount();
    renderWishlistDrawer();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initWishlist(document);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closeWishlistDrawer();
      }
    });
  });

  document.addEventListener('shopify:section:load', function () {
    initWishlist(document);
  });

  window.addEventListener('wishlist:updated', function () {
    updateAllButtons(document);
    updateHeaderCount();
    renderWishlistDrawer();
  });

  window.Wishlist = {
  getWishlist,
  saveWishlist,
  isInWishlist,
  openWishlistDrawer,
  closeWishlistDrawer,
  initWishlist
};
})();